// extracted by mini-css-extract-plugin
export default {"MainBody":"home_MainBody__ePM5e","AddNewBtnBox":"home_AddNewBtnBox__uYdHa"};